import script from "./materi.vue?vue&type=script&setup=true&lang=ts"
export * from "./materi.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=7dbe404a&scoped=true&lang=css&external"
import "./materi.vue?vue&type=style&index=1&id=7dbe404a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dbe404a"]])

export default __exports__